import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { NgEntityServiceLoader } from '@datorama/akita-ng-entity-service';
import { Subscription } from 'rxjs';
import { CsProjectFormComponent } from '../project-form/cs-project-form.component';
import { CsProject } from '../state/cs-project.model';
import { csProjectStoreName } from '../state/cs-project.store';
import { CsProjectsService } from '../state/cs-projects.service';

@Component({
  selector: 'app-add-cs-project-dialog',
  templateUrl: './add-cs-project-dialog.component.html',
  styleUrls: ['./add-cs-project-dialog.component.scss']
})
export class AddCsProjectDialogComponent implements OnInit, OnDestroy {
  @ViewChild(CsProjectFormComponent) projectForm: CsProjectFormComponent;

  private internalError: string;
  private internalIsBusy: boolean;
  private loaderSubscription: Subscription;

  public get error(): string {
      return this.internalError;
  }

  public get isBusy(): boolean {
    return this.internalIsBusy;
  }

  constructor(private service: CsProjectsService,
              private loader: NgEntityServiceLoader,
              public dialogRef: MatDialogRef<AddCsProjectDialogComponent>) { }

  ngOnInit(): void {
    this.loaderSubscription = this.loader.loadersFor(csProjectStoreName).add$.subscribe(
      isLoading => this.internalIsBusy = isLoading);
  }

  ngOnDestroy(): void {
    this.loaderSubscription.unsubscribe();
  }

  public saveChanges(): void {
    const project = this.projectForm.getProject();
    this.internalError = undefined;
    this.service.add<CsProject>(project).subscribe(
      value => this.dialogRef.close(value.id),
      error => { this.internalError = error.message; });
  }

  public discardChanges(): void {
    this.dialogRef.close();
  }
}
